const apiConfigs = {
  "regional": {
    "apiHost": "https://api-dev.mit.edu",
    "paths": {
      "account": "account-v1",
      "digitalId": "digital-id-v1",
      "feature": "feature-v1",
      "sapProxy": "sap-proxy-v2"
    }
  },
  "global": {
    "apiHost": "https://account-registration-dev.mit.edu/api",
    "paths": {
      "account": "account/v1",
      "digitalId": "digital-id/v1",
      "feature": "feature/v1",
      "sapProxy": "sap-proxy/v2"
    }
  }
};
export default apiConfigs;